import { render } from "./TrayPanelProcedures.vue?vue&type=template&id=9d201ef0&scoped=true"
import script from "./TrayPanelProcedures.vue?vue&type=script&lang=js"
export * from "./TrayPanelProcedures.vue?vue&type=script&lang=js"

import "./TrayPanelProcedures.vue?vue&type=style&index=0&id=9d201ef0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d201ef0"]])

export default __exports__